import React from "react";

export const HitmaxWordmark = ({ size = "text-6xl sm:text-7xl", tagline = true }) => (
  <div className="flex flex-col items-center select-none" data-testid="hitmax-wordmark">
    <img src={`${process.env.PUBLIC_URL || ""}/hitmax-logo.png`} alt="" width="96" height="96" className="h-24 w-24 object-contain mb-4" />
    <div
      className={`font-display font-bold tracking-tight ${size}`}
      style={{ fontStyle: "italic", transform: "skewX(-5deg)", lineHeight: 1.12, overflow: "visible", paddingLeft: "0.12em", paddingRight: "0.28em" }}
    >
      <span className="metal-silver" style={{ display: "inline-block" }}>HIT</span>
      <span className="metal-gold" style={{ display: "inline-block", paddingRight: "0.14em" }}>MAX</span>
    </div>

    {tagline && (
      <>
        <div className="mt-3 flex flex-wrap justify-center gap-x-3 text-[11px] sm:text-sm font-bold tracking-[0.35em] text-white/90 uppercase">
          <span className="hm-tagline-word" style={{ animationDelay: "0.1s" }}>Analyse.</span>
          <span className="hm-tagline-word" style={{ animationDelay: "0.25s" }}>Stats.</span>
          <span className="hm-tagline-word" style={{ animationDelay: "0.4s" }}>Stratégie.</span>
        </div>

        <div className="mt-2 h-[3px] w-40 rounded-full"
          style={{
            transformOrigin: "center",
            background: "linear-gradient(90deg,#00E676,#D4AF37)",
            boxShadow: "0 0 12px rgba(0,230,118,0.5), 0 0 12px rgba(212,175,55,0.5)",
            animation: "hm-sep 1.4s cubic-bezier(0.22,1,0.36,1) 0.5s both",
          }}
        />
      </>
    )}
  </div>
);
